import { render, staticRenderFns } from "./FullScreenLayout.vue?vue&type=template&id=273f69de&scoped=true"
import script from "./FullScreenLayout.vue?vue&type=script&lang=js"
export * from "./FullScreenLayout.vue?vue&type=script&lang=js"
import style0 from "./FullScreenLayout.vue?vue&type=style&index=0&id=273f69de&prod&lang=css"
import style1 from "./FullScreenLayout.vue?vue&type=style&index=1&id=273f69de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f69de",
  null
  
)

export default component.exports